import React from 'react';
import { I18NContext } from '../../I18NContext';
import HeavyDivider from '../common/HeavyDivider';
import MedicationCardLoading from '../common/MedicationCardLoading';

class PickupInstructionsLoading extends React.Component {
    render() {
        return (
            <pui-stack>

                {/* QR Code Loading - Left aligned */}
                <pui-stack direction="vertical" spacingBottom="medium">
                    <div style={{
                        width: "160px",
                        height: "160px",
                        backgroundColor: "#f0f0f0",
                        margin: "0 0 20px 20px", // Added left and bottom padding
                        borderRadius: "4px"
                    }} />
                    <div className="pui-loading-heading-large-dark small-margin-top small-margin-bottom" style={{ width: '60%' }} />
                </pui-stack>

                {/* Pickup Location Loading */}
                <div className="pui-loading-heading-medium-dark small-margin-top small-margin-bottom" style={{ width: '50%' }} />
                <div className="pui-loading-text-large small-margin-bottom" style={{ width: '70%' }} />
                <div className="pui-loading-text-large small-margin-bottom" style={{ width: '80%' }} />
                <div className="pui-loading-text-large small-margin-bottom" style={{ width: '50%' }} />

                {/* Reservation Info Loading */}
                <div style={{
                    width: '100%',
                    height: '80px',
                    backgroundColor: "#FCF0E8",
                    padding: "10px",
                    borderRadius: "4px",
                    marginBottom: "20px"
                }} />

                {/* Help Section Loading */}
                <div className="pui-loading-heading-medium-dark small-margin-top small-margin-bottom" style={{ width: '30%' }} />
                <div className="pui-loading-text-large small-margin-bottom" style={{ width: '80%' }} />
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    marginBottom: '20px'
                }}>
                    <div className="pui-loading-text-large" style={{ width: '40%' }} />
                    <div style={{ width: '20px', height: '20px', backgroundColor: '#f0f0f0' }} />
                </div>

                <HeavyDivider />

                {/* Order Summary Loading */}
                <div className="pui-loading-heading-medium-dark small-margin-bottom" />
                <MedicationCardLoading />
            </pui-stack>
        );
    }
}

PickupInstructionsLoading.contextType = I18NContext;

export default PickupInstructionsLoading;
